import { Util, Request } from "@xt/xtbase";
import { getOrigin as getEnvWsOrigin } from "@/utils/method";
const { getOrigin } = Util;
const { XtAxios4 } = Request;

const URL = getOrigin("www") + "/sapi/v4/aicopytrade/";
const ORDERURL = getOrigin("www") + "/sapi/v4/order/";
// 公共 kline 接口（获取最新价等）
const MARKET_PUBLIC_KLINE_URL = getOrigin("www") + "/sapi/v4/market/public/kline";

// 获取我的跟单总览
export function get_mySummary(config) {
  return XtAxios4.get(URL + "ai-copytrade/my/summary", config);
}

/** 跟单总资产历史曲线（需登录） */
export function get_myAssetCurve(config) {
  return XtAxios4.get(URL + "ai-copytrade/my/asset-curve", config);
}

// 获取我当前跟随的策略列表
export function get_myCurrent(config) {
  return XtAxios4.get(URL + "ai-copytrade/my/current", config);
}

// 获取用户当前持仓列表（某策略下我的持仓，用于计算未实现盈亏）
export function get_myCurrentPositions(strategyId, limit = 20, offset = 0, config) {
  return XtAxios4.get(URL + "ai-copytrade/my/current-positions", {
    ...config,
    params: {
      strategyId,
      limit,
      offset,
      ...(config?.params || {}),
    },
  });
}

// 获取所有运行中的AI策略列表
export function get_strategies(config) {
  return XtAxios4.get(URL + "public/ai-copytrade/strategies", config);
}

// 获取首页推荐的AI策略列表
export function get_homeStrategies(config) {
  return XtAxios4.get(URL + "public/ai-copytrade/strategies/home", config);
}

/** 速算-结束跟单预估（不下单）；折算币以持仓为准 */
export function estimate_unfollow(positionId, config = {}) {
  const { convertCurrencyId: _omit, ...rest } = config;
  return XtAxios4.post(URL + "ai-copytrade/my/estimate-unfollow", { positionId }, rest);
}

/** 速算-提取收益预估（不下单）；amount 为毛收益 USDT，可空表示全部可提；折算币以持仓为准 */
export function estimate_withdraw_profit(positionId, config = {}) {
  const { convertCurrencyId: _omit, amount, ...rest } = config;
  const body = { positionId };
  if (amount != null && amount !== "") {
    body.amount = amount;
  }
  return XtAxios4.post(URL + "ai-copytrade/my/estimate-withdraw-profit", body, rest);
}

// 结束跟单（折算币由持仓决定，不传 convertCurrencyId）
export function unfollow(positionId, config = {}) {
  const { convertCurrencyId: _omit, ...rest } = config;
  return XtAxios4.post(ORDERURL + "ai-copytrade/unfollow", { positionId }, rest);
}

/**
 * 提取收益（POST /ai-copytrade/withdraw-profit）
 * @param {string|number} positionId - 跟单仓位 ID
 * @param {object} config - 含 amount（毛收益 USDT，可空=全部可提）及其它 axios 配置
 */
export function withdraw_profit(positionId, config = {}) {
  const { convertCurrencyId: _omit, amount, ...rest } = config;
  const body = { positionId };
  if (amount != null && amount !== "") {
    body.amount = amount;
  }
  return XtAxios4.post(ORDERURL + "ai-copytrade/withdraw-profit", body, rest);
}

// 获取单个策略的基础详情信息
export function get_strategyDetail(strategyId, config) {
  return XtAxios4.get(URL + `public/ai-copytrade/strategy/${strategyId}`, config);
}

// 获取策略带单表现
export function get_strategyPerformance(strategyId, days = 30, config) {
  return XtAxios4.get(URL + `public/ai-copytrade/strategy/${strategyId}/performance`, {
    ...config,
    params: {
      days,
      ...(config?.params || {})
    }
  });
}

// 获取策略收益率走势图
export function get_strategyReturnTrend(strategyId, days = 30, config) {
  return XtAxios4.get(URL + `public/ai-copytrade/strategy/${strategyId}/return-trend`, {
    ...config,
    params: {
      days,
      ...(config?.params || {})
    }
  });
}

// 获取策略当前持仓
export function get_strategyCurrentPositions(strategyId, config) {
  return XtAxios4.get(URL + `public/ai-copytrade/strategy/${strategyId}/current-positions`, config);
}

/**
 * 获取 kline 数据（如最新价：取最新一条的 close）
 * 接口：/sapi/v4/market/public/kline
 * @param config.params.symbol - 交易对，如 btc_brl_cfd
 * @param config.params.interval - 如 1m
 * @param config.params.limit - 条数，如 1
 * @param config.params.version - 如 2
 */
export function get_cfdKline(config) {
  return XtAxios4.get(MARKET_PUBLIC_KLINE_URL, {
    ...config,
    params: {
      symbol: config?.params?.symbol,
      interval: config?.params?.interval ?? "1m",
      limit: config?.params?.limit ?? 1,
      version: config?.params?.version ?? 2,
      ...config?.params,
    },
  });
}

// 获取策略历史持仓
export function get_strategyHistoryPositions(strategyId, limit = 10, offset = 0, config) {
  return XtAxios4.get(URL + `public/ai-copytrade/strategy/${strategyId}/history-positions`, {
    ...config,
    params: {
      limit,
      offset,
      ...(config?.params || {})
    }
  });
}

// 获取策略跟单用户列表
export function get_strategyFollowers(strategyId, limit = 20, offset = 0, config) {
  return XtAxios4.get(URL + `public/ai-copytrade/strategy/${strategyId}/followers`, {
    ...config,
    params: {
      limit,
      offset,
      ...(config?.params || {})
    }
  });
}

// 开始跟单（amount 为 USDT 本金；convertCurrencyId 选填，不传缺省 USDT）
export function follow(strategyId, amount, config = {}) {
  const { convertCurrencyId, ...rest } = config;
  const body = { strategyId, amount };
  if (convertCurrencyId != null && convertCurrencyId !== "") {
    body.convertCurrencyId = convertCurrencyId;
  }
  return XtAxios4.post(ORDERURL + "ai-copytrade/follow", body, rest);
}

/**
 * 体验券跟单（POST /ai-copytrade/follow-by-coupon）
 * 不传金额，本金由券面值决定；下游 Kafka 异步同步化，建议 timeout ≥ 15s。
 * @param {number|string} couponId - user_coupon.id
 * @param {number|string} strategyId - AI 策略 ID
 */
export function followByCoupon(couponId, strategyId, config = {}) {
  const { timeout = 20000, ...rest } = config;
  return XtAxios4.post(
    ORDERURL + "ai-copytrade/follow-by-coupon",
    {
      couponId: Number(couponId) || couponId,
      strategyId: Number(strategyId) || strategyId,
    },
    { timeout, ...rest }
  );
}

// 加仓（amount 为 USDT 本金；convertCurrencyId 选填，不传缺省 USDT，传值须与持仓折算币一致）
export function addInvestment(positionId, amount, config = {}) {
  const { convertCurrencyId, ...rest } = config;
  const body = { positionId, amount };
  if (convertCurrencyId != null && convertCurrencyId !== "") {
    body.convertCurrencyId = convertCurrencyId;
  }
  return XtAxios4.post(ORDERURL + "ai-copytrade/add-investment", body, rest);
}

// 获取我的历史跟单列表
export function get_myHistory(limit = 20, offset = 0, config) {
  return XtAxios4.get(URL + "ai-copytrade/my/history", {
    ...config,
    params: {
      limit,
      offset,
      ...(config?.params || {}),
    },
  });
}

// 获取我的历史仓位
export function get_myHistoryPositions(limit = 20, offset = 0, config) {
  return XtAxios4.get(URL + "ai-copytrade/my/history-positions", {
    ...config,
    params: {
      limit,
      offset,
      ...(config?.params || {})
    }
  });
}

/** AI-LAB 公开接口（无需鉴权），见 components/Pages/aicopy/AI-LAB接口文档.md */
const AI_LAB_PUBLIC = getOrigin("www") + "/sapi/v4/public/ai-lab";

/** GET /public/ai-lab/fear-greed — 恐惧贪婪指数 */
export function get_aiLabFearGreed(config) {
  return XtAxios4.get(AI_LAB_PUBLIC + "/fear-greed", {
    ...config,
    isAutoPopError: false,
  });
}

/** GET /public/ai-lab/stats/summary — AI 策略总盈亏汇总（totalAsset / totalProfit / returnRate / winRate） */
export function get_aiLabStatsSummary(config) {
  return XtAxios4.get(AI_LAB_PUBLIC + "/stats/summary", {
    ...config,
    isAutoPopError: false,
  });
}

/** GET /public/ai-lab/stats/ranking — AI 策略 PNL 排行（按 totalProfit 降序） */
export function get_aiLabPnlRanking(config) {
  return XtAxios4.get(AI_LAB_PUBLIC + "/stats/ranking", {
    ...config,
    isAutoPopError: false,
  });
}

/** 与 AI-Lab Quant WS / HTTP 一致：仅 en | zh | pt | ar | vi，其余回落 en */
export function resolveAiLabQuantLang(locale) {
  if (locale == null || locale === "") return "en";
  const raw = String(locale).toLowerCase().replace(/_/g, "-");
  const primary = raw.split("-")[0];
  if (primary === "zh" || primary === "cn") return "zh";
  if (primary === "pt") return "pt";
  if (primary === "ar") return "ar";
  if (primary === "vi") return "vi";
  if (primary === "en") return "en";
  return "en";
}

/** GET /public/ai-lab/quant-message — AI Quant 消息分页；请求头 Lang 与 WS lang 同源（见 ws-quant-message-frontend.md §6） */
export function get_aiLabQuantMessage(config) {
  const { locale, ...rest } = config || {};
  const headers = { ...(rest.headers || {}) };
  if (locale != null) {
    headers.Lang = resolveAiLabQuantLang(locale);
  }
  return XtAxios4.get(AI_LAB_PUBLIC + "/quant-message", {
    ...rest,
    headers,
    params: {
      page: 1,
      pageSize: 5,
      desc: true,
      ...(rest?.params || {}),
    },
    isAutoPopError: false,
  });
}

/**
 * WS：进场订阅。若传入 `afterMessageId` / `lastMessageId`，服务端只推 id 大于游标的尾巴 + 后续增量，避免与 HTTP 全量重复（见 http-ws-quant-message-integration.md）。
 */
export function getAiLabQuantMessageWsSubscribeBody(locale, opts = {}) {
  const body = { action: "subscribe", lang: resolveAiLabQuantLang(locale) };
  const sid = opts.strategyId;
  if (sid != null && sid !== "") {
    body.strategyId = String(sid);
  }
  const raw = opts.afterMessageId ?? opts.lastMessageId;
  if (raw != null && raw !== "") {
    const n = typeof raw === "string" ? Number(raw.trim()) : Number(raw);
    if (Number.isFinite(n)) body.afterMessageId = n;
  }
  return body;
}

/** WS §3.2：分页（与 HTTP 同源）；可选用于后续改为 WS 翻页 */
export function buildAiLabQuantMessageWsPageBody(page, pageSize, locale, extra = {}) {
  return {
    page,
    pageSize,
    desc: true,
    lang: resolveAiLabQuantLang(locale),
    ...extra,
  };
}

const QUANT_MESSAGE_WS_PATH = "/ai-lab/quant-message/ws";
/** 本地开发（localhost / 本机 IP）连固定 stream，避免本地网关未转发 WS；其余环境走 stream.{顶级域}，不与主站 www 同域 */
const LOCAL_QUANT_WS_FIXED = "wss://stream.uxmex.com" + QUANT_MESSAGE_WS_PATH;

/** localhost / 127.0.0.1 / 本机局域网 IP — 与 Quant WS 本地兜底同源 */
export function isAiLabQuantLocalDevHostname() {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  if (h === "localhost" || h === "127.0.0.1") return true;
  return /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)(\.(?!$)|$)){4}$/.test(h);
}

export function getAiLabQuantMessageWsUrl() {
  if (isAiLabQuantLocalDevHostname()) return LOCAL_QUANT_WS_FIXED;
  return getEnvWsOrigin("stream", "ws") + QUANT_MESSAGE_WS_PATH;
}

/** GET /public/ai-lab/positions — AI 策略持仓查询 */
export function get_aiLabPositions(config) {
  return XtAxios4.get(AI_LAB_PUBLIC + "/positions", {
    ...config,
    isAutoPopError: false,
  });
}

/** GET /public/ai-lab/strategies/leaderboard — completed-traders 排行（与 spikex-ai 同源） */
export function get_aiLabStrategyLeaderboard(config = {}) {
  const { params, ...rest } = config;
  return XtAxios4.get(AI_LAB_PUBLIC + "/strategies/leaderboard", {
    ...rest,
    params: params || {},
    isAutoPopError: false,
  });
}

/** GET /public/ai-lab/strategies/leaderboard/advanced */
export function get_aiLabStrategyAdvancedLeaderboard(config = {}) {
  const { params, ...rest } = config;
  return XtAxios4.get(AI_LAB_PUBLIC + "/strategies/leaderboard/advanced", {
    ...rest,
    params: params || {},
    isAutoPopError: false,
  });
}

const STRATEGY_WS_PATH = "/ai-lab/strategy/ws";
const LOCAL_STRATEGY_WS_FIXED = "wss://stream.uxmex.com" + STRATEGY_WS_PATH;

/** completed-traders 策略 WS（与 spikex-ai getStrategyWsUrl 同源） */
export function getAiLabStrategyWsUrl() {
  if (isAiLabQuantLocalDevHostname()) return LOCAL_STRATEGY_WS_FIXED;
  return getEnvWsOrigin("stream", "ws") + STRATEGY_WS_PATH;
}

/** WS 订阅 LEADERBOARD；competition 为 aggressive|balanced|conservative，aggregate 不传 */
export function getAiLabStrategyLeaderboardWsSubscribeBody(opts = {}) {
  const body = { type: "LEADERBOARD" };
  if (opts.average) body.average = true;
  const competition = opts.competition;
  if (competition && competition !== "aggregate") {
    body.competition = competition;
  }
  return body;
}
